export default "__VITE_ASSET__sB3tJnhu95b2xe93amOGHw__"